module.exports = __webpack_public_path__ + "f917071e6d0f450634f9fb5beebe6ba0.png";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/CWC.png
// module id = 949
// module chunks = 0